/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { TimeOnly } from './timeOnly.schema';

export const DailyActivityMonitoringLogHeaderSummaryDto = zod.object({
  "id": zod.string().uuid().optional(),
  "logId": zod.string().optional(),
  "coordinatorId": zod.string().uuid().optional(),
  "coordinatorName": zod.string().optional(),
  "dailyWorkSchedule": zod.string().optional(),
  "date": zod.coerce.date().optional(),
  "time": zod.lazy(() => TimeOnly).optional(),
  "branchId": zod.number().optional(),
  "branchName": zod.string().optional(),
  "statusId": zod.number().optional(),
  "statusName": zod.string().optional(),
  "createdBy": zod.string().optional(),
  "createdDate": zod.coerce.date().optional()
});

export type DailyActivityMonitoringLogHeaderSummaryDto = zod.input<typeof DailyActivityMonitoringLogHeaderSummaryDto>;
export type DailyActivityMonitoringLogHeaderSummaryDtoOutput = zod.output<typeof DailyActivityMonitoringLogHeaderSummaryDto>;
